import clsx from 'clsx';
import React, { memo, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import styles from './AnimatedRoute.module.scss';

const isNestedRoute = (pathname: string) => pathname.split('/').length > 2;

const getAnimationClass = (currentPath: string) => {
  const currentIsNested = isNestedRoute(currentPath);
  return currentIsNested
    ? styles.routeSlideFromRight || ''
    : styles.routeSlideFromLeft || '';
};

export const AnimatedRoute = memo(
  ({ children }: { children: React.ReactNode }) => {
    const location = useLocation();

    const [animationClass, setAnimationClass] = useState('');

    useEffect(() => {
      const animationClass = getAnimationClass(location.pathname);
      setAnimationClass(animationClass);
      const timer = setTimeout(() => setAnimationClass(''), 1000);
      return () => clearTimeout(timer);
    }, [location.pathname]);

    return (
      <div className={clsx(styles.animatedRoute, animationClass)}>
        {children}
      </div>
    );
  },
);
